import { GlobalStore } from '@siloreal:app:store';

export const partialize = (state: GlobalStore) => ({
  user_locale: state.user_locale,
  auth_access_token: state.auth_access_token,
  auth_verify_access_token: state.auth_verify_access_token,
  auth_refresh_token: state.auth_refresh_token,
  auth_expiration_token_date: state.auth_expiration_token_date,
  filter_silobag_list: state.filter_silobag_list,
});
